import { toRem } from '@nxtpeople/nxt-vue-library';
import mitt from 'mitt';
import { createApp } from 'vue';
import Shimmer from 'vue3-shimmer';
import App from './App.vue';
import router from './core/router';
import store from './core/store';

import i18n from './i18n';
const emitter = mitt();

import { useMediaQueries } from '@nxtpeople/nxt-styles';
import { setupDirectives } from './core/helpers/directives.helper';
import keycloak from './core/helpers/keycloak.helper';
import { initSentry } from './core/helpers/sentry.helper';
const { sm } = useMediaQueries();

document.addEventListener('DOMContentLoaded', async () => {
   const app = createApp(App);

   app.use(keycloak);
   app.use(store);
   app.use(router);
   app.use(i18n);
   app.use(Shimmer);

   const IS_IOS =
      ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

   if (!IS_IOS) {
      initSentry(app, router);
   }

   app.provide('emitter', emitter);

   setupDirectives(app);

   app.config.globalProperties.emitter = emitter;
   app.config.globalProperties.$toRem = toRem;

   app.mount('#app');
});
